import { render, staticRenderFns } from "./PageSideBar.vue?vue&type=template&id=bf6a1e8e&scoped=true"
import script from "./PageSideBar.vue?vue&type=script&lang=js"
export * from "./PageSideBar.vue?vue&type=script&lang=js"
import style0 from "./PageSideBar.vue?vue&type=style&index=0&id=bf6a1e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6a1e8e",
  null
  
)

export default component.exports